import { User } from "@/v2/types";
import ArFormCombobox from "../form/ComboBoxFormField";
import { FieldValues, Path } from "react-hook-form";
import FindAllUser from "@/v2/api/users/FindAll";

export function ArUserCombobox<T extends FieldValues>({
    name,
    storeFullObject = false,
    setSelectedEmployee,
    label = "Select AR user coordinator",
    placeholder = "Select co ordinator...",
    defaultValueId,
    defaultValue,
}: {
    name: Path<T>;
    label?: string;
    placeholder?: string;
    storeFullObject?: boolean;
    setSelectedEmployee?: (value: User | null) => void;
    defaultValueId?: string;
    defaultValue: User | null;
}) {
    return (
        <ArFormCombobox<T, User>
            defaultValueId={defaultValueId}
            defaultValue={defaultValue}
            name={name}
            label={label}
            queryKey="users"
            queryFn={async ({ pageParam, search, limit }) =>
                FindAllUser({ skip: pageParam, search, limit })
            }
            additionalFilters={{ is_ar_employee: { eq: [true] } }}
            getDisplayValue={(employee) => employee.full_name}
            renderItem={(employee) => (
                <div className="flex flex-col">
                    <span>{employee.full_name}</span>
                </div>
            )}
            placeholder={placeholder}
            width="w-full"
            storeFullObject={storeFullObject}
            onItemSelect={(employee: User | null) => {
                setSelectedEmployee && setSelectedEmployee(employee);
            }}
        />
    );
}
